// The "QR Code from your shop app" announcement has no start date: it shows as soon as
// it is deployed, and stops on 5 Oct 2569 (B.E.) = 2026-10-05, Thailand time, for
// everyone. The explicit +07:00 offset keeps it independent of the device's time zone.
export const NOTICE_HIDE_FROM = new Date('2026-10-05T00:00:00+07:00').getTime();

export function isNoticeVisible(now = Date.now()) {
  return now < NOTICE_HIDE_FROM;
}

// A user can close the announcement; that is remembered in this browser. It is a NEW
// key on purpose: the old PromptPay announcement used another one, and reusing it
// would hide this announcement from everyone who had already seen that one.
export const NOTICE_DISMISSED_KEY = 'qr-template-notice-dismissed';

function browserStorage() {
  try {
    return window.localStorage;
  } catch (error) {
    return null; // blocked (private mode, policy): behave as if nothing is remembered
  }
}

export function isNoticeDismissed(storage = browserStorage()) {
  try {
    return Boolean(storage) && storage.getItem(NOTICE_DISMISSED_KEY) === '1';
  } catch (error) {
    return false;
  }
}

export function dismissNotice(storage = browserStorage()) {
  try {
    if (storage) storage.setItem(NOTICE_DISMISSED_KEY, '1');
  } catch (error) {
    // Not remembered; the announcement is still closed for this page view.
  }
}
